<template>
  <div class="big">
    <el-dialog :title="`${!isAdd ? '添加' : '编辑'}图片`"
               :visible.sync="dialog"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="add-img-dia">
        <el-form :model="imgForm"
                 :rules="imgRules"
                 ref="imgFormRef"
                 label-width="70px">
          <el-form-item label="题目"
                        prop="title">
            <el-input v-model="imgForm.title"
                      placeholder="请输入"></el-input>
          </el-form-item>

          <div class="way">
            <el-form-item label="方式"
                          prop="answer_obj">
              <el-select v-model="imgForm.answer_obj"
                         placeholder="请选择方式">
                <el-option label="患者回答"
                           :value="1"></el-option>
                <el-option label="医生回答"
                           :value="2"></el-option>
                <el-option label="医生患者都可回答"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否必填"
                          prop="is_write"
                          label-width="80px"
                          class="img-box">
              <el-radio-group v-model="imgForm.is_write">
                <el-radio :label="1">必填</el-radio>
                <el-radio :label="0">非必填</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label="数量限制"
                        prop="img_num">
            <el-select v-model="imgForm.img_num"
                       placeholder="请选择数量">
              <el-option v-for="item in 9"
                         :key="item"
                         :label="item"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否设置描述"
                        prop="is_desc"
                        label-width="100px">
            <el-radio-group v-model="imgForm.is_desc">
              <el-radio :label="1">设置</el-radio>
              <el-radio :label="0">不设置</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item v-if="isDesc == 1"
                      label=""
                      class="cus-textarea">
          <p class="prompt">暗提示文字，引导提示回答您的问题（非必填）</p>
          <el-input type="textarea"
                    v-model="imgForm.desc"></el-input>
        </el-form-item> -->
        </el-form>
      </div>
      <div style="text-align: center; padding: 10px 0">
        <el-button @click="closeShow(false)">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('imgFormRef')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    isAdd: {
      type: Number,
      require: true
    },
    content: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: true,
      imgForm: {
        title: '',
        answer_obj: '',
        is_write: 1,
        img_num: 1,
        is_desc: 1
      },
      imgRules: {
        title: [
          { required: true, message: '请输入题目', trigger: 'blur' },
          { max: 100, message: '题目长度100字以内', trigger: 'blur' }
        ],
        answer_obj: [
          { required: true, message: '请选择方式', trigger: 'change' }
        ]
        // desc: [{ max: 30, message: '题目长度100字以内', trigger: 'blur' }]
      }
    };
  },
  created() {
    if (this.isAdd) {
      this.imgForm = _.pick(this.content, [
        'title',
        'answer_obj',
        'is_write',
        '$index',
        'img_num',
        'is_desc'
      ]);
      // this.imgForm.is_desc = 1;
    }
  },
  methods: {
    closeShow(data) {
      this.$emit('closeShow', data);
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = Object.assign(this.imgForm, {
            item_type: 5
          });
          this.closeShow(data);
        } else {
          return false;
        }
      });
    },
    resetForm() {}
  }
};
</script>
<style lang="scss" scoped>
.add-img-dia {
  padding: 20px 20px 0 20px;
  box-sizing: border-box;

  .way {
    display: flex;
    height: 50px;
    .img-box {
      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        .el-radio-group {
          display: flex;
        }
      }
    }
  }
  .cus-textarea {
    margin-top: 10px;
    margin-bottom: 40px;
    .prompt {
      height: 20px;
      line-height: 20px;
      margin: 0;
      color: #cac7c7;
    }
  }
}
</style>
